module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.30510",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4991",
      "atom": "static-1.5357",
      "client-types": "static-1.496",
      "conversations-error-reporting": "static-1.9166",
      "conversations-internal-pub-sub": "static-1.16261",
      "conversations-internal-schema": "static-1.13363",
      "conversations-message-history": "static-1.13499",
      "conversations-test-sdk": "static-1.10777",
      "conversations-visitor-experience-components": "static-1.23873",
      "data-fetching-client": "static-1.9930",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.5869",
      "hs-test-utils": "static-1.8304",
      "hubspot-dlb": "static-2.1882",
      "HubStyleTokens": "static-2.11759",
      "I18n": "static-7.1668",
      "immer": "static-1.94",
      "jasmine-immutable": "static-1.3294",
      "jasmine-runner": "static-1.6725",
      "quartz": "static-1.7421",
      "react-dlb": "static-1.88",
      "react-select-plus": "static-1.109",
      "react-transition-group": "static-2.70",
      "redux-thunk": "static-2.77",
      "reselect": "static-3.9",
      "sanitize": "static-1.4747",
      "StyleGuideUI": "static-3.500",
      "transmute": "static-2.85",
      "urlinator": "static-1.4805",
      "usage-tracker": "static-1.7628",
      "usage-tracker-core": "static-1.7478",
      "usage-tracker-public": "static-1.7439",
      "viral-links-lib": "static-1.7348",
      "visitor-ui-component-library": "static-1.6423",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.5081",
      "conversations-prop-types": "static-1.7728",
      "conversations-visitor-message-history": "static-1.22610",
      "cssUtils": "static-1.892",
      "enviro": "static-4.455",
      "flux-actions": "static-1.365",
      "foundations-components": "static-1.8448",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6485",
      "interactive-cards": "static-1.333",
      "hubspot-url-utils": "static-1.4297",
      "immutable": "static-2.83",
      "metrics-js": "static-1.9867",
      "PatternValidationJS": "static-1.3168",
      "PortalIdParser": "static-2.404",
      "pulse": "static-1.900",
      "raven": "static-3.5925",
      "react": "static-7.192",
      "react-aria": "static-1.70",
      "react-dom": "static-7.85",
      "react-redux": "static-7.75",
      "react-rhumb": "static-1.16990",
      "react-utils": "static-2.5536",
      "redux": "static-4.76",
      "rpc-client-utils": "static-1.4938",
      "redux-toolkit": "static-1.75",
      "sanitize-text": "static-1.8426",
      "signup-constants": "static-1.19564",
      "styled-components": "static-2.95",
      "usage-tracker-multi": "static-1.6042",
      "visitor-ui-component-library-icons": "static-1.6234",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3600",
      "moment": "static-3.75",
      "quartz-config": "static-1.1199",
      "quartz-core": "static-1.6640",
      "foundations-assets": "static-1.5155",
      "foundations-theming": "static-1.4746",
      "UIComponents": "static-3.8705",
      "conversations-async-data": "static-2.7942",
      "customer-data-email": "static-1.18490",
      "cv-backend-services": "static-1.1592",
      "immutable-less": "static-1.4923",
      "conversations-skeleton-state": "static-1.7519",
      "crm-events-viz-core": "static-1.33986",
      "customer-data-objects": "static-1.7963",
      "icons": "static-2.677",
      "react-input-autosize": "static-2.17",
      "react-performance-metrics-lib": "static-1.828",
      "ui-images": "static-2.1238",
      "apollo-stack-hubspot": "static-3.91",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.86",
      "HeadJS": "static-2.793",
      "framer-motion": "static-1.76",
      "hs-test-utils-bend-plugin": "static-1.3415",
      "msw": "static-1.39",
      "testing-library": "static-1.156",
      "i18n-data": "static-1.229",
      "moment-timezone": "static-5.88",
      "jasmine": "static-4.4586",
      "signup-ui-url-generator": "static-2.8335",
      "HubStyle": "static-2.12066",
      "quartz-i18n": "static-1.1096",
      "sassPrefix": "static-1.163",
      "bend-plugin-foundations-components": "static-1.4717",
      "floating-ui": "static-1.62",
      "foundations-theming-specialty": "static-1.2462",
      "hs-story-utils": "static-1.9698",
      "react-create-root-preference": "static-1.67",
      "react-virtualized": "static-2.104",
      "tanstack-table": "static-1.59",
      "trellis-assets": "static-1.2565",
      "ui-fonts": "static-1.1021",
      "hs-locale-management": "static-1.273",
      "bend-plugin-pulse": "static-1.403",
      "batch-promise": "static-1.1815",
      "chirp-fetch": "static-1.2167",
      "event-emitter": "static-1.1226",
      "fast-json-patch": "static-1.67",
      "hub-http-janus": "static-1.874",
      "quick-fetch": "static-1.4110",
      "csstype": "static-1.50",
      "quartz-head": "static-1.1086",
      "web-vitals": "static-1.12",
      "bend-plugin-chirp-manifest": "static-1.348",
      "quartz-routing": "static-1.851",
      "usage-tracker-anonymous": "static-1.6045",
      "bender-build-tools": "static-1.3422",
      "opentelemetry-fe-types": "static-1.42",
      "dispatcher": "static-1.142",
      "general-store": "static-6.20",
      "hubspotter-http": "static-1.4844",
      "mobile-manifest-mixins": "static-1.574",
      "module-federation": "static-1.30",
      "opentelemetry-fe": "static-1.417",
      "quartz-auth": "static-1.1096",
      "quartz-test": "static-1.1096",
      "quartz-tracking": "static-1.800",
      "trellis-components": "static-1.2584",
      "usage-tracker-container": "static-1.7618",
      "bend-plugin-foundations-theming": "static-1.3229",
      "foundations-theming-base": "static-1.3731",
      "stylex": "static-1.38",
      "react-immutable-proptypes": "static-2.8",
      "apollo-dlb": "static-3.97",
      "apollo-link-hub-http": "static-2.4928",
      "customer-data-ui-utilities": "static-1.10101",
      "FileManagerCore": "static-1.39928",
      "FileManagerLib": "static-1.40069",
      "hubspot-apollo-client": "static-1.5151",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.533",
      "timezone-utils": "static-2.5517",
      "ui-gdpr-components": "static-1.10625",
      "ts-schema": "static-1.4273",
      "ai-components-ui-library": "static-1.9661",
      "avatar-components": "static-1.2766",
      "content-assistance-lib": "static-1.8164",
      "crm-component-utils": "static-1.39784",
      "crm-display-components": "static-1.25534",
      "crm-fe-perf": "static-1.23175",
      "crm-links": "static-1.6601",
      "crm-message-bus": "static-1.43702",
      "crm-search-service-types": "static-1.1427",
      "crm-source-interpretation-lib": "static-1.5601",
      "customer-data-communicator": "static-1.46280",
      "customer-data-filters-ui": "static-1.40836",
      "customer-data-objects-ui-components": "static-1.13303",
      "customer-data-properties": "static-1.52503",
      "customer-data-rte": "static-1.33603",
      "draft-plugins": "static-2.22120",
      "file-manager-components": "static-1.24429",
      "trellis-theming": "static-1.1242",
      "framework-data-schema-resolvers": "static-1.7165",
      "frontend-preferences-client": "static-1.8196",
      "hubspot-prosemirror": "static-1.18921",
      "object-comments-thread-lib": "static-1.11307",
      "prosemirror-user-and-team-at-mentions": "static-1.1155",
      "reference-resolvers-lite": "static-1.8376",
      "ui-addon-upgrades": "static-9.18346",
      "universal-associations-select": "static-1.11346",
      "universal-record-utils-lib": "static-1.1812",
      "wootric-nps": "static-1.7179",
      "inbound-db-properties-service-client": "static-1.4036",
      "property-translator": "static-1.5671",
      "segments-query-core": "static-1.1695",
      "stylex-utils": "static-1.137",
      "opentelemetry-web": "static-1.11",
      "hub-http-shared-msw-handlers": "static-1.10572",
      "hubspotter-http-shared-msw-handlers": "static-1.10570",
      "usage-tracker-session-replay": "static-1.5314",
      "base-ui": "static-1.19",
      "react-day-picker": "static-1.7",
      "tanstack-virtual": "static-1.36",
      "react-dnd-compat": "static-1.4890",
      "breeze-artifacts-sdk": "static-1.256",
      "audio-components": "static-1.6306",
      "ContentUtils": "static-1.69076",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29772",
      "FileManagerImages": "static-1.37580",
      "foundations-components-legacy": "static-1.1473",
      "html-to-image": "static-1.58",
      "immerable": "static-1.4422",
      "react-colorpicker": "static-2.10481",
      "ui-universal-auth": "static-1.9349",
      "video-components": "static-1.14109",
      "video-data-lib": "static-1.35765",
      "video-embed": "static-1.36599",
      "hubspot-apollo-cache": "static-1.610",
      "chatspot-core": "static-1.22840",
      "copilot-toolkit": "static-1.11803",
      "superstore": "static-1.5029",
      "ui-addon-video-player": "static-1.8975",
      "ui-coaching-tips": "static-1.29259",
      "card-properties-lib": "static-1.44958",
      "commerce-subscription-lib": "static-1.37725",
      "crm-actions": "static-1.6625",
      "crm-cards-sdk": "static-1.44491",
      "customer-data-properties-shared-msw-handlers": "static-1.9899",
      "customer-data-property-utils": "static-1.8374",
      "customer-data-tracking": "static-1.7154",
      "hs-resources": "static-1.465",
      "inbound-db-meta-service-client": "static-1.3718",
      "framework-data-table": "static-2.12500",
      "location-customization-utils-lib": "static-1.10047",
      "restore-request-side-panel-lib": "static-1.1618",
      "calling-error-reporting": "static-1.31598",
      "calling-internal-common": "static-1.31591",
      "calling-usage-tracker": "static-1.6810",
      "crm_data": "static-4.92770",
      "customer-data-content": "static-1.27768",
      "draft-content-plugins": "static-1.28863",
      "draft-convert": "static-2.77",
      "draft-extend": "static-3.80",
      "draft-js": "static-5.82",
      "draft-signature-plugin": "static-1.24672",
      "EmailSignatureEditor": "static-1.24960",
      "hubspot-prosemirror-plugins": "static-1.18913",
      "integration-settings-components": "static-1.16160",
      "integrations-lib": "static-1.16979",
      "integrations-tracking-lib": "static-1.5881",
      "native-integrations-shared-strings": "static-1.8051",
      "nav-meta": "static-1.30407",
      "onboarding-scopes": "static-1.6726",
      "outreach-assistant-email-generation": "static-1.6775",
      "prosemirror": "static-1.13",
      "prosemirror-copilot": "static-1.12281",
      "quotes-client-types": "static-1.38873",
      "reference-resolvers": "static-1.8455",
      "rich-text-lib": "static-1.20270",
      "sales-email-signature-service-client": "static-1.4116",
      "sequences-lib": "static-1.8499",
      "ui-addon-i18n": "static-1.11419",
      "ui-addon-iframeable": "static-1.9349",
      "ui-business-units-lib": "static-1.9360",
      "ui-shepherd-react": "static-3.10540",
      "user-context": "static-1.5391",
      "whatsapp-sending-lib": "static-1.6709",
      "customer-data-filters-ui-msw-helpers": "static-1.23271",
      "customer-data-reference-ui-components": "static-1.13451",
      "events-data-lib": "static-1.516",
      "FormUrlGenerator": "static-2.5000",
      "framework-builder-read-service-client": "static-1.4201",
      "multi-account-reference-resolvers": "static-1.1272",
      "onboarding-tours": "static-1.17079",
      "reporting-datasets-permissions-lib": "static-1.14417",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21879",
      "calling-global-api": "static-1.65504",
      "calling-lifecycle-internal": "static-1.66886",
      "calling-lifecycle-messages": "static-1.59180",
      "commerce-products-lib": "static-1.10475",
      "conditional-properties-service-client": "static-1.3992",
      "crm-index-visualization-core": "static-1.4509",
      "crm-pipelines-api-client-types": "static-1.4327",
      "external-options-client-types": "static-1.4319",
      "formula-editor": "static-1.14715",
      "google-libphonenumber": "static-1.42",
      "inbounddb-objects-service-types": "static-1.4406",
      "meetings-icalendar-utils-lib": "static-1.908",
      "multi-currency-client-types": "static-1.3888",
      "object-builder-ui-client": "static-1.49609",
      "pipeline-validation-client-types": "static-1.4161",
      "property-value-citations": "static-1.3117",
      "smart-data-capture-core": "static-1.83",
      "smart-property-lib": "static-1.8236",
      "tiered-pricing": "static-1.1914",
      "topics-actions-lib": "static-1.436",
      "trial-components-library": "static-1.14066",
      "ui-addon-form-validation": "static-1.11255",
      "zustand": "static-1.79",
      "breeze-engine-lib": "static-1.1648",
      "video-components-external": "static-1.12107",
      "fdsr-migration-layer": "static-1.284",
      "framework-data-schema-quick-fetch": "static-1.7070",
      "persist-promise": "static-1.3972",
      "content-media-capture": "static-1.5379",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.26128",
      "knowledge-content-types": "static-1.8638",
      "payment-link-components": "static-1.24119",
      "ui-addon-emoji-picker": "static-1.10158",
      "call-summary": "static-1.40194",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10718",
      "laboratory-lib": "static-3.7424",
      "merchandise-lib": "static-1.276",
      "purchase-motions-components": "static-1.6314",
      "crm-object-search-query-utilities": "static-1.10153",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "cms-field-types": "static-1.5087",
      "content-icons-ui": "static-1.2335",
      "underscore": "static-1.8",
      "unified-auth-core-lib": "static-1.1145",
      "social-insights-client-types": "static-1.22685",
      "outpost": "static-1.4431",
      "markdown-it": "static-1.6",
      "magpie-lib": "static-1.5736",
      "magpie-types": "static-1.5196",
      "simple-logging-lib": "static-1.3324",
      "growth-onboarding-feedback-components": "static-1.6856",
      "customer-data-sidebar": "static-2.46691",
      "enrichment-lib": "static-1.264",
      "ui-addon-draggable-compat": "static-2.4538",
      "commerce-billing-lib": "static-1.20095",
      "commerce-shared-components-lib": "static-1.19174",
      "commerce-tools-ui-lib": "static-1.10998",
      "customer-data-associations": "static-1.7599",
      "tasks-actions-lib": "static-1.71",
      "reporting-data": "static-1.68725",
      "ui-addon-draggable": "static-3.5030",
      "crm-record-cards-service-types": "static-1.3766",
      "crm_universal": "static-1.22462",
      "SalesContentIndexUI": "static-3.9596",
      "content-embed-lib": "static-1.7609",
      "data-model-builder-lib": "static-1.13082",
      "remote-dom": "static-1.2",
      "remote-ui": "static-1.70",
      "ui-components-test-utils": "static-1.5896",
      "ui-extensions-remote-renderer": "static-1.17831",
      "universal-page-editor-lib": "static-1.3280",
      "integrations-error-boundary-lib": "static-1.14394",
      "redux-observable": "static-1.72",
      "ReduxMessenger": "static-2.10642",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.863",
      "messaging-types-lib": "static-1.46820",
      "ai-addon-copilot-preview": "static-1.8873",
      "copilot-plugins": "static-1.11775",
      "data-token-picker": "static-1.16851",
      "sequences-client-types-lib": "static-1.8356",
      "foundations-components-test-utils": "static-1.5931",
      "navigation-messaging": "static-1.8097",
      "getting-started-shared-tasks": "static-1.19185",
      "getting-started-shared-tasks-store": "static-1.18303",
      "onboarding-tours-utils": "static-1.1145",
      "messaging-usage-based-billing-components-lib": "static-1.1945",
      "whatsapp-management-lib": "static-1.9868",
      "growth-data-modal": "static-1.5857",
      "growth-onboarding-confetti": "static-1.3334",
      "growth-onboarding-next-action-utils": "static-1.2640",
      "navigation-components": "static-1.18770",
      "onboarding-tours-client": "static-1.5293",
      "ui-shepherd-tracker": "static-1.7921",
      "shared-worker-versioning": "static-1.11313",
      "voice-sms-access-library": "static-1.1974",
      "commerce-permissions": "static-1.1049",
      "products-iframe-lib": "static-1.8541",
      "products-ui-components-shared-msw-handlers": "static-1.10954",
      "crm-index-associations-lib": "static-1.6713",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10655",
      "sales-views-client-types": "static-1.4527",
      "bark-lib": "static-1.16784",
      "browser-prettier": "static-1.11",
      "codemirror": "static-5.99",
      "crm-properties-common-lib": "static-1.6162",
      "react-codemirror": "static-1.10912",
      "data-agent-kit": "static-1.611",
      "fsm": "static-1.4021",
      "policy-lib": "static-1.7071",
      "embedded-academy-lib": "static-1.15459",
      "hubs-service-types": "static-1.1530",
      "purchase-motions-api": "static-1.6317",
      "breeze-engine-chat-components": "static-1.626",
      "breeze-engine-core": "static-1.926",
      "highlight.js": "static-1.83",
      "content-media-composition-data-lib": "static-1.13183",
      "content-media-compositions": "static-2.17190",
      "idb-keyval": "static-1.48",
      "media-bridge-lib": "static-1.19371",
      "fix-webm-duration": "static-1.27",
      "notification-sounds": "static-1.4697",
      "seat-types-lib": "static-1.668",
      "ui-addon-opt": "static-4.8637",
      "commerce-tours-lib": "static-1.6575",
      "growth-onboarding-reliability": "static-1.5352",
      "sales-checkout-service-client": "static-1.3803",
      "calling-cross-tab-library": "static-1.19569",
      "calling-lifecycle-usage-tracker": "static-1.9357",
      "reactive-lib": "static-1.993",
      "card-payment-highlight-lib": "static-1.37926",
      "commerce-contract-lib": "static-1.13247",
      "invoices-highlight-card-lib": "static-1.55655",
      "orders-highlight-card-lib": "static-1.22145",
      "products-highlight-card-lib": "static-1.18758",
      "quotes-highlight-card-lib": "static-1.72783",
      "data-agent-utils": "static-1.326",
      "usage-based-billing-components-lib": "static-1.10150",
      "utility-belt": "static-1.2807",
      "payments-enrollment-embed-lib": "static-1.23747",
      "stripe-embedded-components": "static-1.7962",
      "growth-onboarding-empty-states": "static-1.6231",
      "InboxConnectUtils": "static-4.15509",
      "payments-post-enroll-local-storage-lib": "static-1.5378",
      "qrcode-generator": "static-1.73",
      "reporting-client-types": "static-1.2664",
      "react-flip-move": "static-1.75",
      "FireAlarmUi": "static-1.4700",
      "sales-templates-service-types-lib": "static-1.4364",
      "ui-asset-management-lib": "static-1.11370",
      "association-settings-lib": "static-1.10963",
      "collaboration-sidebar": "static-1.58664",
      "conditional-property-settings-components": "static-1.174",
      "conditional-property-settings-modal": "static-1.13085",
      "data-model-commons-lib": "static-1.13334",
      "ExportDialog": "static-6.10652",
      "final-form": "static-1.75",
      "nudge-client-utils": "static-1.3114",
      "object-definition-builder-lib": "static-1.7381",
      "property-management-iframe": "static-1.14079",
      "property-usages-lib": "static-1.5764",
      "reactflow": "static-1.68",
      "simple-data-table": "static-1.3487",
      "used-in-list-lib": "static-1.7236",
      "visual-association": "static-1.6163",
      "highcharts": "static-8.108",
      "reporting-visualizations": "static-1.60800",
      "ui-extensibility-client-types": "static-1.4191",
      "adobe-sign-auth-lib": "static-1.410",
      "ads-unified-auth-lib": "static-1.1214",
      "google-sheets-integration-lib": "static-1.981",
      "microsoft-drive-auth-lib": "static-1.76",
      "surveymonkey-integration-lib": "static-1.421",
      "slack-ui-library": "static-1.10670",
      "automation-platform-service-types": "static-1.2662",
      "ContentData": "static-1.69151",
      "email-portal-health-service-types": "static-1.1252",
      "marketing-email-service-types": "static-1.2080",
      "ai-rendering-library": "static-1.11052",
      "ai-settings-ui-library": "static-1.8287",
      "ui-brand-identity-lib": "static-1.16366",
      "messaging-shared-utils-lib": "static-1.1394",
      "messaging-user-info-utils-lib": "static-1.1564",
      "content-whatsapp-service-types": "static-1.562",
      "marketing-platform-lib": "static-1.7142",
      "short-messages-app-service-client": "static-1.4186",
      "ui-tool-access": "static-1.10426",
      "onboarding-data-sync-lib": "static-1.2465",
      "growth-onboarding-next-action-components": "static-1.2668",
      "user-context-client": "static-1.4781",
      "nest": "static-1.508",
      "calling-orchestration-schema": "static-1.36751",
      "diff-match-patch": "static-1.7",
      "react-reducer-toolkit": "static-1.16316",
      "browser-eslint": "static-2.57",
      "trellis-story-utils": "static-1.4781",
      "storybook-react": "static-1.37",
      "academy-common-lib": "static-1.14919",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.40993",
      "accounting-integrations-ui-components": "static-1.7500",
      "invoices-ui-lib": "static-1.55671",
      "commerce-products-api": "static-1.2662",
      "invoices-iframe-lib": "static-1.57729",
      "quotes-modal-lib": "static-1.103461",
      "quotes-ui-lib": "static-1.81504",
      "one-click-checkout": "static-1.342",
      "platform-infra-nav-components": "static-1.7873",
      "reporting-ui-components": "static-2.65995",
      "subscription-experience-data-types": "static-1.15223",
      "marketplace-ui-apps-core": "static-1.19196",
      "stripe-connect-js": "static-1.75",
      "ui-addon-react-router-dom": "static-1.9810",
      "hub-http-contrib": "static-1.3312",
      "ui-addon-sales-email": "static-1.5486",
      "nested-table": "static-1.507",
      "chatspot-widget-iframe": "static-1.22831",
      "collaboration-sidebar-common": "static-1.3461",
      "conditional-property-settings-data": "static-1.192",
      "nudge-custom-function-registry": "static-1.2871",
      "nudge-renderer-utils": "static-1.3190",
      "whisper-core-api": "static-1.7275",
      "property-management-common": "static-1.6367",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15541",
      "advanced-menus-lib": "static-1.12418",
      "ui-memberships-settings-lib": "static-1.34792",
      "breeze-onboarding-components": "static-1.666",
      "mermaid": "static-1.3",
      "reporting-action-components": "static-1.41970",
      "reporting-snowflake": "static-1.57342",
      "upgrade-components-lib": "static-1.482",
      "meetings-connect-utils-lib": "static-1.7881",
      "academy-service-client": "static-1.3960",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4676",
      "trellis-ecosystem": "static-1.7592",
      "commerce-tax-lib": "static-1.811",
      "price-books-api": "static-1.1686",
      "price-books-components": "static-1.1744",
      "property-description-translator": "static-1.4114",
      "ramp-editor": "static-1.848",
      "commerce-analytics-service-client": "static-1.3791",
      "totals-ui-components": "static-1.24247",
      "checkout-sdk": "static-3.24280",
      "payment-method-components": "static-1.7121",
      "touchless-buying-components": "static-1.6148",
      "upgrade-catalog-service-types": "static-1.3748",
      "reporting-plugins": "static-1.10709",
      "reporting-reports": "static-1.68402",
      "edison-service-client-types": "static-1.665",
      "developer-experience-shared-components": "static-1.10777",
      "marketplace-ui-client-types": "static-1.18071",
      "marketplace-ui-common": "static-1.20664",
      "ui-addon-integrations-directory-panel": "static-2.8297",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.426",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15540",
      "simple-menus-lib": "static-1.17057",
      "onboarding-journeys-lib": "static-1.866",
      "dashboard-lib": "static-1.82732",
      "share-with-third-party-component-lib": "static-1.8977",
      "line-items-api": "static-1.1062",
      "commerce-totals-service-types": "static-1.4012",
      "hub-http-rxjs": "static-1.838",
      "normalizr": "static-3.9",
      "ramda": "static-1.7",
      "billing-payments-client-types": "static-1.4261",
      "company-details-components": "static-1.6475",
      "emoji-regex": "static-1.7",
      "pricing-pages-ui-components": "static-1.15648",
      "quote-checkout-service-types": "static-1.3727",
      "campaign-roi-lib": "static-1.10102",
      "campaigns-utils-lib": "static-1.3477",
      "ui-addon-calendars": "static-2.5601",
      "apps-service-types": "static-1.4013",
      "oauth-service-types": "static-1.4509",
      "ui-product-approvals-common": "static-1.963",
      "redux-actions": "static-3.68",
      "company-details-service-types": "static-1.4212",
      "pricing-pages-api": "static-1.15513"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.30510",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4991",
      "atom": "/atom/static-1.5357",
      "client-types": "/client-types/static-1.496",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.9166",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16261",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13363",
      "conversations-message-history": "/conversations-message-history/static-1.13499",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10777",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.23873",
      "data-fetching-client": "/data-fetching-client/static-1.9930",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.5869",
      "hs-test-utils": "/hs-test-utils/static-1.8304",
      "hubspot-dlb": "/hubspot-dlb/static-2.1882",
      "HubStyleTokens": "/HubStyleTokens/static-2.11759",
      "I18n": "/I18n/static-7.1668",
      "immer": "/immer/static-1.94",
      "jasmine-immutable": "/jasmine-immutable/static-1.3294",
      "jasmine-runner": "/jasmine-runner/static-1.6725",
      "quartz": "/quartz/static-1.7421",
      "react-dlb": "/react-dlb/static-1.88",
      "react-select-plus": "/react-select-plus/static-1.109",
      "react-transition-group": "/react-transition-group/static-2.70",
      "redux-thunk": "/redux-thunk/static-2.77",
      "reselect": "/reselect/static-3.9",
      "sanitize": "/sanitize/static-1.4747",
      "StyleGuideUI": "/StyleGuideUI/static-3.500",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4805",
      "usage-tracker": "/usage-tracker/static-1.7628",
      "usage-tracker-core": "/usage-tracker-core/static-1.7478",
      "usage-tracker-public": "/usage-tracker-public/static-1.7439",
      "viral-links-lib": "/viral-links-lib/static-1.7348",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6423",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.5081",
      "conversations-prop-types": "/conversations-prop-types/static-1.7728",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.22610",
      "cssUtils": "/cssUtils/static-1.892",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.365",
      "foundations-components": "/foundations-components/static-1.8448",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6485",
      "interactive-cards": "/interactive-cards/static-1.333",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
      "immutable": "/immutable/static-2.83",
      "metrics-js": "/metrics-js/static-1.9867",
      "PatternValidationJS": "/PatternValidationJS/static-1.3168",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "pulse": "/pulse/static-1.900",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.192",
      "react-aria": "/react-aria/static-1.70",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.75",
      "react-rhumb": "/react-rhumb/static-1.16990",
      "react-utils": "/react-utils/static-2.5536",
      "redux": "/redux/static-4.76",
      "rpc-client-utils": "/rpc-client-utils/static-1.4938",
      "redux-toolkit": "/redux-toolkit/static-1.75",
      "sanitize-text": "/sanitize-text/static-1.8426",
      "signup-constants": "/signup-constants/static-1.19564",
      "styled-components": "/styled-components/static-2.95",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.6042",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6234",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3600",
      "moment": "/moment/static-3.75",
      "quartz-config": "/quartz-config/static-1.1199",
      "quartz-core": "/quartz-core/static-1.6640",
      "foundations-assets": "/foundations-assets/static-1.5155",
      "foundations-theming": "/foundations-theming/static-1.4746",
      "UIComponents": "/UIComponents/static-3.8705",
      "conversations-async-data": "/conversations-async-data/static-2.7942",
      "customer-data-email": "/customer-data-email/static-1.18490",
      "cv-backend-services": "/cv-backend-services/static-1.1592",
      "immutable-less": "/immutable-less/static-1.4923",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7519",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.33986",
      "customer-data-objects": "/customer-data-objects/static-1.7963",
      "icons": "/icons/static-2.677",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.828",
      "ui-images": "/ui-images/static-2.1238",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.91",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.86",
      "HeadJS": "/HeadJS/static-2.793",
      "framer-motion": "/framer-motion/static-1.76",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3415",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.156",
      "i18n-data": "/i18n-data/static-1.229",
      "moment-timezone": "/moment-timezone/static-5.88",
      "jasmine": "/jasmine/static-4.4586",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8335",
      "HubStyle": "/HubStyle/static-2.12066",
      "quartz-i18n": "/quartz-i18n/static-1.1096",
      "sassPrefix": "/sassPrefix/static-1.163",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4717",
      "floating-ui": "/floating-ui/static-1.62",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2462",
      "hs-story-utils": "/hs-story-utils/static-1.9698",
      "react-create-root-preference": "/react-create-root-preference/static-1.67",
      "react-virtualized": "/react-virtualized/static-2.104",
      "tanstack-table": "/tanstack-table/static-1.59",
      "trellis-assets": "/trellis-assets/static-1.2565",
      "ui-fonts": "/ui-fonts/static-1.1021",
      "hs-locale-management": "/hs-locale-management/static-1.273",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.403",
      "batch-promise": "/batch-promise/static-1.1815",
      "chirp-fetch": "/chirp-fetch/static-1.2167",
      "event-emitter": "/event-emitter/static-1.1226",
      "fast-json-patch": "/fast-json-patch/static-1.67",
      "hub-http-janus": "/hub-http-janus/static-1.874",
      "quick-fetch": "/quick-fetch/static-1.4110",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.1086",
      "web-vitals": "/web-vitals/static-1.12",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.348",
      "quartz-routing": "/quartz-routing/static-1.851",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6045",
      "bender-build-tools": "/bender-build-tools/static-1.3422",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.42",
      "dispatcher": "/dispatcher/static-1.142",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http": "/hubspotter-http/static-1.4844",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.574",
      "module-federation": "/module-federation/static-1.30",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.417",
      "quartz-auth": "/quartz-auth/static-1.1096",
      "quartz-test": "/quartz-test/static-1.1096",
      "quartz-tracking": "/quartz-tracking/static-1.800",
      "trellis-components": "/trellis-components/static-1.2584",
      "usage-tracker-container": "/usage-tracker-container/static-1.7618",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3229",
      "foundations-theming-base": "/foundations-theming-base/static-1.3731",
      "stylex": "/stylex/static-1.38",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "apollo-dlb": "/apollo-dlb/static-3.97",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4928",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10101",
      "FileManagerCore": "/FileManagerCore/static-1.39928",
      "FileManagerLib": "/FileManagerLib/static-1.40069",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5151",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.533",
      "timezone-utils": "/timezone-utils/static-2.5517",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
      "ts-schema": "/ts-schema/static-1.4273",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9661",
      "avatar-components": "/avatar-components/static-1.2766",
      "content-assistance-lib": "/content-assistance-lib/static-1.8164",
      "crm-component-utils": "/crm-component-utils/static-1.39784",
      "crm-display-components": "/crm-display-components/static-1.25534",
      "crm-fe-perf": "/crm-fe-perf/static-1.23175",
      "crm-links": "/crm-links/static-1.6601",
      "crm-message-bus": "/crm-message-bus/static-1.43702",
      "crm-search-service-types": "/crm-search-service-types/static-1.1427",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5601",
      "customer-data-communicator": "/customer-data-communicator/static-1.46280",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40836",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13303",
      "customer-data-properties": "/customer-data-properties/static-1.52503",
      "customer-data-rte": "/customer-data-rte/static-1.33603",
      "draft-plugins": "/draft-plugins/static-2.22120",
      "file-manager-components": "/file-manager-components/static-1.24429",
      "trellis-theming": "/trellis-theming/static-1.1242",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7165",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8196",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18921",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.11307",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.1155",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8376",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18346",
      "universal-associations-select": "/universal-associations-select/static-1.11346",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1812",
      "wootric-nps": "/wootric-nps/static-1.7179",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4036",
      "property-translator": "/property-translator/static-1.5671",
      "segments-query-core": "/segments-query-core/static-1.1695",
      "stylex-utils": "/stylex-utils/static-1.137",
      "opentelemetry-web": "/opentelemetry-web/static-1.11",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10572",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10570",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5314",
      "base-ui": "/base-ui/static-1.19",
      "react-day-picker": "/react-day-picker/static-1.7",
      "tanstack-virtual": "/tanstack-virtual/static-1.36",
      "react-dnd-compat": "/react-dnd-compat/static-1.4890",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.256",
      "audio-components": "/audio-components/static-1.6306",
      "ContentUtils": "/ContentUtils/static-1.69076",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29772",
      "FileManagerImages": "/FileManagerImages/static-1.37580",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1473",
      "html-to-image": "/html-to-image/static-1.58",
      "immerable": "/immerable/static-1.4422",
      "react-colorpicker": "/react-colorpicker/static-2.10481",
      "ui-universal-auth": "/ui-universal-auth/static-1.9349",
      "video-components": "/video-components/static-1.14109",
      "video-data-lib": "/video-data-lib/static-1.35765",
      "video-embed": "/video-embed/static-1.36599",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.610",
      "chatspot-core": "/chatspot-core/static-1.22840",
      "copilot-toolkit": "/copilot-toolkit/static-1.11803",
      "superstore": "/superstore/static-1.5029",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8975",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29259",
      "card-properties-lib": "/card-properties-lib/static-1.44958",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37725",
      "crm-actions": "/crm-actions/static-1.6625",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.44491",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9899",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8374",
      "customer-data-tracking": "/customer-data-tracking/static-1.7154",
      "hs-resources": "/hs-resources/static-1.465",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "framework-data-table": "/framework-data-table/static-2.12500",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10047",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1618",
      "calling-error-reporting": "/calling-error-reporting/static-1.31598",
      "calling-internal-common": "/calling-internal-common/static-1.31591",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6810",
      "crm_data": "/crm_data/static-4.92770",
      "customer-data-content": "/customer-data-content/static-1.27768",
      "draft-content-plugins": "/draft-content-plugins/static-1.28863",
      "draft-convert": "/draft-convert/static-2.77",
      "draft-extend": "/draft-extend/static-3.80",
      "draft-js": "/draft-js/static-5.82",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24672",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24960",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18913",
      "integration-settings-components": "/integration-settings-components/static-1.16160",
      "integrations-lib": "/integrations-lib/static-1.16979",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5881",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8051",
      "nav-meta": "/nav-meta/static-1.30407",
      "onboarding-scopes": "/onboarding-scopes/static-1.6726",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6775",
      "prosemirror": "/prosemirror/static-1.13",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.12281",
      "quotes-client-types": "/quotes-client-types/static-1.38873",
      "reference-resolvers": "/reference-resolvers/static-1.8455",
      "rich-text-lib": "/rich-text-lib/static-1.20270",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4116",
      "sequences-lib": "/sequences-lib/static-1.8499",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11419",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9349",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9360",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10540",
      "user-context": "/user-context/static-1.5391",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.6709",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23271",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13451",
      "events-data-lib": "/events-data-lib/static-1.516",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.5000",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4201",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1272",
      "onboarding-tours": "/onboarding-tours/static-1.17079",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14417",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21879",
      "calling-global-api": "/calling-global-api/static-1.65504",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66886",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59180",
      "commerce-products-lib": "/commerce-products-lib/static-1.10475",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3992",
      "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4509",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4327",
      "external-options-client-types": "/external-options-client-types/static-1.4319",
      "formula-editor": "/formula-editor/static-1.14715",
      "google-libphonenumber": "/google-libphonenumber/static-1.42",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4406",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.908",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3888",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.49609",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4161",
      "property-value-citations": "/property-value-citations/static-1.3117",
      "smart-data-capture-core": "/smart-data-capture-core/static-1.83",
      "smart-property-lib": "/smart-property-lib/static-1.8236",
      "tiered-pricing": "/tiered-pricing/static-1.1914",
      "topics-actions-lib": "/topics-actions-lib/static-1.436",
      "trial-components-library": "/trial-components-library/static-1.14066",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11255",
      "zustand": "/zustand/static-1.79",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1648",
      "video-components-external": "/video-components-external/static-1.12107",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.284",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7070",
      "persist-promise": "/persist-promise/static-1.3972",
      "content-media-capture": "/content-media-capture/static-1.5379",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.26128",
      "knowledge-content-types": "/knowledge-content-types/static-1.8638",
      "payment-link-components": "/payment-link-components/static-1.24119",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10158",
      "call-summary": "/call-summary/static-1.40194",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10718",
      "laboratory-lib": "/laboratory-lib/static-3.7424",
      "merchandise-lib": "/merchandise-lib/static-1.276",
      "purchase-motions-components": "/purchase-motions-components/static-1.6314",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10153",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "cms-field-types": "/cms-field-types/static-1.5087",
      "content-icons-ui": "/content-icons-ui/static-1.2335",
      "underscore": "/underscore/static-1.8",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1145",
      "social-insights-client-types": "/social-insights-client-types/static-1.22685",
      "outpost": "/outpost/static-1.4431",
      "markdown-it": "/markdown-it/static-1.6",
      "magpie-lib": "/magpie-lib/static-1.5736",
      "magpie-types": "/magpie-types/static-1.5196",
      "simple-logging-lib": "/simple-logging-lib/static-1.3324",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6856",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46691",
      "enrichment-lib": "/enrichment-lib/static-1.264",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4538",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.20095",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19174",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10998",
      "customer-data-associations": "/customer-data-associations/static-1.7599",
      "tasks-actions-lib": "/tasks-actions-lib/static-1.71",
      "reporting-data": "/reporting-data/static-1.68725",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.5030",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3766",
      "crm_universal": "/crm_universal/static-1.22462",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9596",
      "content-embed-lib": "/content-embed-lib/static-1.7609",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.13082",
      "remote-dom": "/remote-dom/static-1.2",
      "remote-ui": "/remote-ui/static-1.70",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5896",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.17831",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3280",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14394",
      "redux-observable": "/redux-observable/static-1.72",
      "ReduxMessenger": "/ReduxMessenger/static-2.10642",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.863",
      "messaging-types-lib": "/messaging-types-lib/static-1.46820",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8873",
      "copilot-plugins": "/copilot-plugins/static-1.11775",
      "data-token-picker": "/data-token-picker/static-1.16851",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8356",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5931",
      "navigation-messaging": "/navigation-messaging/static-1.8097",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19185",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18303",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1145",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1945",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.9868",
      "growth-data-modal": "/growth-data-modal/static-1.5857",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3334",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2640",
      "navigation-components": "/navigation-components/static-1.18770",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5293",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7921",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11313",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.1974",
      "commerce-permissions": "/commerce-permissions/static-1.1049",
      "products-iframe-lib": "/products-iframe-lib/static-1.8541",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10954",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6713",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10655",
      "sales-views-client-types": "/sales-views-client-types/static-1.4527",
      "bark-lib": "/bark-lib/static-1.16784",
      "browser-prettier": "/browser-prettier/static-1.11",
      "codemirror": "/codemirror/static-5.99",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6162",
      "react-codemirror": "/react-codemirror/static-1.10912",
      "data-agent-kit": "/data-agent-kit/static-1.611",
      "fsm": "/fsm/static-1.4021",
      "policy-lib": "/policy-lib/static-1.7071",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.15459",
      "hubs-service-types": "/hubs-service-types/static-1.1530",
      "purchase-motions-api": "/purchase-motions-api/static-1.6317",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.626",
      "breeze-engine-core": "/breeze-engine-core/static-1.926",
      "highlight.js": "/highlight.js/static-1.83",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13183",
      "content-media-compositions": "/content-media-compositions/static-2.17190",
      "idb-keyval": "/idb-keyval/static-1.48",
      "media-bridge-lib": "/media-bridge-lib/static-1.19371",
      "fix-webm-duration": "/fix-webm-duration/static-1.27",
      "notification-sounds": "/notification-sounds/static-1.4697",
      "seat-types-lib": "/seat-types-lib/static-1.668",
      "ui-addon-opt": "/ui-addon-opt/static-4.8637",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6575",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5352",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3803",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19569",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.9357",
      "reactive-lib": "/reactive-lib/static-1.993",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37926",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.13247",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55655",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22145",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18758",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72783",
      "data-agent-utils": "/data-agent-utils/static-1.326",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10150",
      "utility-belt": "/utility-belt/static-1.2807",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23747",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7962",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6231",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15509",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5378",
      "qrcode-generator": "/qrcode-generator/static-1.73",
      "reporting-client-types": "/reporting-client-types/static-1.2664",
      "react-flip-move": "/react-flip-move/static-1.75",
      "FireAlarmUi": "/FireAlarmUi/static-1.4700",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4364",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11370",
      "association-settings-lib": "/association-settings-lib/static-1.10963",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.58664",
      "conditional-property-settings-components": "/conditional-property-settings-components/static-1.174",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.13085",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.13334",
      "ExportDialog": "/ExportDialog/static-6.10652",
      "final-form": "/final-form/static-1.75",
      "nudge-client-utils": "/nudge-client-utils/static-1.3114",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7381",
      "property-management-iframe": "/property-management-iframe/static-1.14079",
      "property-usages-lib": "/property-usages-lib/static-1.5764",
      "reactflow": "/reactflow/static-1.68",
      "simple-data-table": "/simple-data-table/static-1.3487",
      "used-in-list-lib": "/used-in-list-lib/static-1.7236",
      "visual-association": "/visual-association/static-1.6163",
      "highcharts": "/highcharts/static-8.108",
      "reporting-visualizations": "/reporting-visualizations/static-1.60800",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4191",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.410",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1214",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.981",
      "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.76",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.421",
      "slack-ui-library": "/slack-ui-library/static-1.10670",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2662",
      "ContentData": "/ContentData/static-1.69151",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1252",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.2080",
      "ai-rendering-library": "/ai-rendering-library/static-1.11052",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8287",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16366",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1394",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1564",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.562",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7142",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4186",
      "ui-tool-access": "/ui-tool-access/static-1.10426",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2465",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2668",
      "user-context-client": "/user-context-client/static-1.4781",
      "nest": "/nest/static-1.508",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36751",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16316",
      "browser-eslint": "/browser-eslint/static-2.57",
      "trellis-story-utils": "/trellis-story-utils/static-1.4781",
      "storybook-react": "/storybook-react/static-1.37",
      "academy-common-lib": "/academy-common-lib/static-1.14919",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.40993",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7500",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.55671",
      "commerce-products-api": "/commerce-products-api/static-1.2662",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57729",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.103461",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.81504",
      "one-click-checkout": "/one-click-checkout/static-1.342",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7873",
      "reporting-ui-components": "/reporting-ui-components/static-2.65995",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15223",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19196",
      "stripe-connect-js": "/stripe-connect-js/static-1.75",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9810",
      "hub-http-contrib": "/hub-http-contrib/static-1.3312",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5486",
      "nested-table": "/nested-table/static-1.507",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22831",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3461",
      "conditional-property-settings-data": "/conditional-property-settings-data/static-1.192",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2871",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3190",
      "whisper-core-api": "/whisper-core-api/static-1.7275",
      "property-management-common": "/property-management-common/static-1.6367",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15541",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12418",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34792",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.666",
      "mermaid": "/mermaid/static-1.3",
      "reporting-action-components": "/reporting-action-components/static-1.41970",
      "reporting-snowflake": "/reporting-snowflake/static-1.57342",
      "upgrade-components-lib": "/upgrade-components-lib/static-1.482",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7881",
      "academy-service-client": "/academy-service-client/static-1.3960",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4676",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7592",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.811",
      "price-books-api": "/price-books-api/static-1.1686",
      "price-books-components": "/price-books-components/static-1.1744",
      "property-description-translator": "/property-description-translator/static-1.4114",
      "ramp-editor": "/ramp-editor/static-1.848",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3791",
      "totals-ui-components": "/totals-ui-components/static-1.24247",
      "checkout-sdk": "/checkout-sdk/static-3.24280",
      "payment-method-components": "/payment-method-components/static-1.7121",
      "touchless-buying-components": "/touchless-buying-components/static-1.6148",
      "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3748",
      "reporting-plugins": "/reporting-plugins/static-1.10709",
      "reporting-reports": "/reporting-reports/static-1.68402",
      "edison-service-client-types": "/edison-service-client-types/static-1.665",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10777",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18071",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.20664",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8297",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.426",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15540",
      "simple-menus-lib": "/simple-menus-lib/static-1.17057",
      "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.866",
      "dashboard-lib": "/dashboard-lib/static-1.82732",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8977",
      "line-items-api": "/line-items-api/static-1.1062",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4012",
      "hub-http-rxjs": "/hub-http-rxjs/static-1.838",
      "normalizr": "/normalizr/static-3.9",
      "ramda": "/ramda/static-1.7",
      "billing-payments-client-types": "/billing-payments-client-types/static-1.4261",
      "company-details-components": "/company-details-components/static-1.6475",
      "emoji-regex": "/emoji-regex/static-1.7",
      "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15648",
      "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3727",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.10102",
      "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3477",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5601",
      "apps-service-types": "/apps-service-types/static-1.4013",
      "oauth-service-types": "/oauth-service-types/static-1.4509",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.963",
      "redux-actions": "/redux-actions/static-3.68",
      "company-details-service-types": "/company-details-service-types/static-1.4212",
      "pricing-pages-api": "/pricing-pages-api/static-1.15513"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.30510",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};